import React from "react";
import styled from "styled-components";
import { style } from "./style";

const NotificationsCount = styled.span`
  background-color: ${style.colors.red.primary};
  border-radius: 50vh;
  color: ${style.colors.white};
  display: flex;
  font-size: 10px;
  font-weight: ${style.vars.fontWeight.bold};
  line-height: 1;
  padding: 4px;
  min-width: 18px;
  align-items: center;
  justify-content: center;
`;

export type NotificationsBadgeProps = {
  count: number;
  className?: string;
};

export const NotificationsBadge: React.FC<NotificationsBadgeProps> = ({ count, className }) => {
  return <NotificationsCount className={className}>{count > 99 ? "99+" : count}</NotificationsCount>;
};
